import 'lightgallery.js/dist/css/lightgallery.css'
import 'lightgallery.js/dist/js/lightgallery.min.js'

const gallery = {
  init() {
    lightGallery(document.getElementById('lightgallery'));
  }
};

export default gallery;
